import { serviceLoading } from 'common/loaderReducer';
import * as React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import { RootState } from '../../../../../store/types';
import { WidgetContainer,WidgetTitle,InlineLeft,Info,ToolTipContainer,IconContainer,ToolTipLabel,EmptyStateContainer,EmptyStateMessage } from '../styles';
import { Button } from './styles';
import ChartDoughnut from 'components/ChartDoughnut'
import info from '../../../../../common/images/icon-info.svg';
import { GET_OFFER_INSIGHTSTATS_API_REQUEST } from 'features/Dealers/Performance/state/actionTypes';
import Loader from 'components/Loader';
import publishspecials from './publishspecials.png'
import { CalculatePercentageOfTotal, GetNumberKMG } from 'features/Dealers/Performance/Widgets/utils';

const WidgetPublishedUpdatedPosts = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    const rootProps = useSelector((rootState: RootState) => {
        const isRequesting = serviceLoading(rootState, [GET_OFFER_INSIGHTSTATS_API_REQUEST]);
        return {
            dealerId: rootState.dealers.dealer.selectedDealer?.id,
            WidgetUpdatedDeletedPorcentage: CalculatePercentageOfTotal(rootState.dealers.offerInsights.stats==undefined?undefined:rootState.dealers.offerInsights.stats?.totalUpdated + rootState.dealers.offerInsights.stats?.totalDeleted,rootState.dealers.offerInsights.stats?.totalPosts),
            WidgetPublished: rootState.dealers.offerInsights.stats==undefined?0:rootState.dealers.offerInsights.stats?.totalPosts,
            WidgetLegendItems: [{color:'#7BABF7',label:'Published: ' + (rootState.dealers.offerInsights.stats==undefined?0:rootState.dealers.offerInsights.stats?.totalPosts)},{color:'#FF7319',label:'Updated or deleted: ' + (rootState.dealers.offerInsights.stats==undefined?0:(rootState.dealers.offerInsights.stats?.totalUpdated + rootState.dealers.offerInsights.stats?.totalDeleted))}],
            totalPosts: rootState.dealers.offerInsights.stats?.totalPosts,
            specialsUrl: rootState.dealers.offerInsights.stats?.specials_url,
            isRequesting
        }
    }, shallowEqual);

    return (
        <WidgetContainer>
            <InlineLeft>
            <WidgetTitle>
                Special Posts: Published and Modified
            </WidgetTitle>
            <IconContainer>
            <Info>
            <img src={info}></img>
            </Info>
            <ToolTipContainer>
                <ToolTipLabel>
                    This is the total sum of posts that have been published, updated or deleted from the
                    moment Listing Manager was synced to GBP to now. Multiple updates or deletions for 
                    the same post will count as one.
                </ToolTipLabel>
            </ToolTipContainer>
            </IconContainer>
            </InlineLeft>
            {
                rootProps.isRequesting &&
                    <Loader/>
            }
            {
                !rootProps.isRequesting &&
                rootProps.totalPosts !==0 &&
                <ChartDoughnut
                    OuterRingData={[rootProps.WidgetUpdatedDeletedPorcentage,(100-rootProps.WidgetUpdatedDeletedPorcentage)]}
                    InnerRingData={[100]}
                    OuterRingColors={['#FF7319','#FFFFFF']}
                    InnerRingColors={['#7BABF7']}
                    OuterRingDataSpacer={0}
                    InnerRingDataSpacer={0}
                    innerTextLine1={GetNumberKMG(rootProps.WidgetPublished)}
                    innerTextLine2={'SPECIAL POSTS'}
                    ShowLegend={true}
                    LegendItems={rootProps.WidgetLegendItems}
                    OuterRingAnimation={true}
                    OuterRingCutOut={92}
                    InnerRingCutOut={80}
                    LegendPosition={window.innerWidth>2200?'RIGHT':'BOTTOM'}
                />
            }
            {
                !rootProps.isRequesting &&
                rootProps.totalPosts ===0 &&
                <EmptyStateContainer>
                    <img src={publishspecials}/>
                    <EmptyStateMessage>
                        Publish your specials!
                    </EmptyStateMessage>
                    <Button 
                        onClick={() => { window.open(rootProps.specialsUrl, "_blank");}}>
                        Go to my ESM
                    </Button>
                </EmptyStateContainer>
            }
        </WidgetContainer>
    )
}

export default WidgetPublishedUpdatedPosts
